import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { Driver } from '../../models/predictive.models';
import { Simulation } from './widget-predictive.component';

@EnableClassTelemetry()
@Injectable()
export class SimulationStorageService {
  private simulations: Simulation[];

  constructor() {}

  init(simulations: Simulation[]): void {
    this.simulations = simulations;
  }

  set(breakdown: string, driver: Driver): void {
    let simulation = this.simulations.find((s) => s.breakdown === breakdown);
    if (!simulation) {
      simulation = {
        breakdown: breakdown,
        drivers: [],
      };

      this.simulations.push(simulation);
    }

    let simulationDriver = simulation.drivers.find((d) => d.driver === driver.name);
    if (!simulationDriver) {
      simulationDriver = {
        driver: driver.name,
        value: driver.simulated,
      };

      simulation.drivers.push(simulationDriver);
    }

    simulationDriver.value = driver.simulated;
  }

  get(breakdown: string, driver: string): number | null {
    const simulation = this.simulations.find((s) => s.breakdown === breakdown);
    if (!simulation) {
      return null;
    }

    const simulatedValue = simulation.drivers.find((d) => d.driver === driver);
    if (!simulatedValue) {
      return null;
    }

    return simulatedValue.value;
  }

  removeSimulation(breakdown: string): void {
    const index = this.simulations.findIndex((s) => s.breakdown === breakdown);
    this.simulations.splice(index, 1);
  }

  removeSimulatedValue(breakdown: string, driver: string): void {
    const simulation = this.simulations.find((s) => s.breakdown === breakdown);
    const index = simulation.drivers.findIndex((d) => d.driver === driver);
    simulation.drivers.splice(index, 1);

    if (!simulation.drivers.length) {
      this.removeSimulation(breakdown);
    }
  }

  clear(): void {
    this.simulations.splice(0, this.simulations.length);
  }
}
